import React, { useState, useEffect } from "react";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";

import { useNavigate } from "react-router-dom";

export default function ForgotPass() {

  const navigate = useNavigate();

  const [newPassword, setnewPassword] = useState("");
  const [re_Pass, setre_Pass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const handlePasswordChange = (event) => {
    setnewPassword(event.target.value);
  };
  const handleRePass = (event) => {
    setre_Pass(event.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibilityRePass = () => {
    setShowPassword2(!showPassword2);
  };

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 m-auto mt-5">
            <div className="card border-0 rounded-2 p-4 login-card">
              <div className="card border-0 rounded-0 bg-transparent">
                <div className="text-center" style={{ fontSize: 30, fontWeight: 600, fontfamily: "Poppins", fontStyle: "normal", lineHeight: "normal", color: "#000", }}>Reset Your Password</div>
                <div className="mt-4">
                  <div className="text-start" style={{ fontSize: 14, fontWeight: 400, fontFamily: "Poppins", color: "#000", }}>Old Password</div>
                  <div class="input-group mb-3" style={{ border: "1px solid #000", borderRadius: 40 }}>
                    <input type="text" className="form-control ps-4 border-0 bg-transparent input-field-color" placeholder="Old Password" aria-label="Username" aria-describedby="basic-addon1"/>
                    <span className="input-group-text border-0 bg-transparent" id="basic-addon1" style={{ color: "#32A7FC" }}>@</span>
                  </div>
                  <div className="text-start" style={{ fontSize: 14, fontWeight: 400, fontFamily: "Poppins", }}>New Password</div>
                  <div class="input-group" style={{ border: "1px solid #000", borderRadius: 40 }}>
                    <input type={showPassword ? "text" : "password"} value={newPassword} onChange={handlePasswordChange} className="form-control ps-4 border-0 bg-transparent input-field-color" placeholder="Enter New password" aria-label="Username" aria-describedby="basic-addon2"/>
                    <span onClick={togglePasswordVisibility} className="input-group-text password-toggle border-0 bg-transparent" id="basic-addon2" style={{ color: "#32A7FC" }}>
                      {showPassword ? (<><IoIosEye /></>) : (<><IoIosEyeOff /></>)}
                    </span>
                  </div>
                  <div className="text-start mt-3" style={{ fontSize: 14, fontWeight: 400, fontFamily: "Poppins", }}>Re-Enter Password</div>
                  <div class="input-group" style={{ border: "1px solid #000", borderRadius: 40 }}>
                    <input type={showPassword2 ? "text" : "password"} value={re_Pass} onChange={handleRePass} className="form-control ps-4 border-0 bg-transparent input-field-color" placeholder="Re-Enter Password" aria-label="Username" aria-describedby="basic-addon2"/>
                    <span onClick={togglePasswordVisibilityRePass} className="input-group-text password-toggle border-0 bg-transparent" id="basic-addon2" style={{ color: "#32A7FC" }}>
                      {showPassword2 ? (<><IoIosEye /></>) : (<><IoIosEyeOff /></>)}
                    </span>
                  </div>
                </div>
                <button className="btn-hover color-3 rounded-5 px-4 py-0 mt-5">Reset Password</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
